import React from 'react';
import PropTypes from 'prop-types';
import { Spin, Tooltip } from 'antd';
import moment from 'moment';
import WaterIcon from 'mdi-react/WaterIcon';
import './ServiceStatusComponent.scss';
import { SERVICE_STAUS } from '../../../utils/constants';

const getFormattedDate = (date: string): string => (date ? moment(date).format('DD/MM/YYYY [às] HH:mm') : '');
const getFormattedscheduleDate = (date: string): string => (date ? moment.utc(date).format('DD/MM/YYYY') : '');

const ServiceStatusComponent = (props): JSX.Element => {
  const {
    loading,
    statusesList,
    currentStatusIndex,
    canceled,
  } = props;

  return (
    <div className="ServiceStatusComponent">
      <Spin
        tip="Carregando..."
        spinning={loading}
      >
        {
          statusesList.map((value, index) => {
            const lastItem = index === currentStatusIndex ? 'last-item' : '';

            const statusItem = index <= currentStatusIndex
              && (canceled ? 'canceled-item' : 'completed-item');

            return (
              <div className="status-item" key={`status-item-${value.id}`}>
                {
                  lastItem
                    ? (
                      <div className={`${statusItem} last-item`}>
                        <div className="item-icon-container">
                          <div className="item-icon">
                            {
                              SERVICE_STAUS?.find((item) => item.id === value.id)?.icon != null
                                ? SERVICE_STAUS?.find((item) => item.id === value.id)?.icon
                                : <WaterIcon />
                            }
                          </div>
                        </div>
                        <div className="item-complement" />
                      </div>
                    )
                    : (
                      <div className={`${statusItem}`} style={{ height: 84 }}>
                        <div className="item-icon-container-dot">
                          <div className="item-dot-container">
                            <div className="item-dot" />
                          </div>
                        </div>
                        <div className="item-complement-dot" />
                      </div>
                    )
                }
                <div className={`${statusItem} ${lastItem} item-text`}>
                  <div className="item-name">
                    {
                      value.scheduleDate
                        ? `Agendado para ${getFormattedscheduleDate(value.scheduleDate)}`
                        : value.stepName
                    }
                  </div>
                  <div className="item-time">{getFormattedDate(value.date)}</div>
                  {
                    lastItem
                    && canceled
                    && (
                      <div className="cancellation-reason">
                        <Tooltip title={value.reasonForCancellation} placement="bottom">
                          <span>Motivo do cancelamento</span>
                        </Tooltip>
                      </div>
                    )
                  }
                </div>
              </div>
            );
          })
        }
      </Spin>
    </div>
  );
};

ServiceStatusComponent.propTypes = {
  loading: PropTypes.bool.isRequired,
  statusesList: PropTypes.arrayOf(PropTypes.any).isRequired,
  currentStatusIndex: PropTypes.number.isRequired,
  canceled: PropTypes.bool.isRequired,
};

ServiceStatusComponent.defaultProps = {};

export default ServiceStatusComponent;
